module.exports = __webpack_public_path__ + "img/video_image.02db72d.jpg";